﻿import React from 'react';

// components
import PossessionsAccordionItem from './PossessionsAccordionItem';

const PossessionsAccordion = (props) => {

    const [expanded, setExpanded] = React.useState(false);

    const combinedData = props.data;

    return (
        <ul>
            {
                combinedData && combinedData.length > 0 &&
                combinedData.map((combined, ind) => (
                    <PossessionsAccordionItem
                        id={ind}
                        key={ind}
                        combined={combined}
                        ind={ind}
                        expanded={expanded}
                        setExpanded={setExpanded} />
                ))
            }
        </ul>
     )
};

export default PossessionsAccordion;

